/**
 * Affichage d'une personne (traitant, utilisateur connecté) à partir de son
 * nom. Le nom vient de la liste des traitants (agents) ou, pour un client qui
 * n'a pas cette liste, du point lui-même (`support_users` renvoyé par l'API).
 */

/** Initiales (deux au plus) d'un nom ; l'identifiant si le nom est inconnu. */
export function initialsOf(name: string | undefined | null, id: number): string {
  const ini = (name ?? '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
  return ini || String(id);
}

/** Libellé d'une personne : son nom, sinon « user #id » (identifiant seul). */
export function personLabel(name: string | undefined | null, id: number, fallback?: string): string {
  const n = name?.trim();
  return n || fallback || `user #${id}`;
}

/** Nom d'un traitant d'un point parmi les noms renvoyés avec le point. */
export function supportName(
  supportUsers: { id_user: number; nom_user: string }[] | undefined,
  id: number,
): string | undefined {
  return supportUsers?.find((s) => s.id_user === id)?.nom_user;
}
